// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__IdRma","footer":"ModalCreateQualiphyProcedure_footer__15NO4","additionData":"ModalCreateQualiphyProcedure_additionData__1ix4-"};